import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import priceFormat from '../../utils/showPriceFormat';
import './Order.css';

const POrder = (props) => {
    const { number, factureNumber, fullName, telephone, info } = props;
    const { products, totalPrice, insertDate, status, address, postPrice } = props;
    const [showOrder, setShowOrder] = useState(false);

    return (
        <React.Fragment>

            <div className="order-layer">
                <header className="order-layer-header">
                    <div className="d-flex justify-content-between align-items-center p-2">
                        <span className="order-number d-flex flex-wrap col-6 px-0" >
                            <div className="mr-1">
                                <span className="font-weight-bold text-muted border rounded-circle px-2">{number}</span>
                            </div>
                            <div>
                                <span className="gs">{factureNumber.split('-')[0]}</span>
                                <span className="">-</span>
                                <span className="">{factureNumber.split('-')[1]}</span>
                            </div>
                            <div className="col-12 ml-3">
                                <span className='small'>
                                    {priceFormat(totalPrice)} تومان
                                </span>
                            </div>
                        </span>
                        <span className="col-1 px-0">
                            <button
                                style={{ position: 'relative', top: '7px', left: '7px' }}
                                className="btn btn-success rounded-circle px-1 py-0"
                                onClick={() => setShowOrder(!showOrder)}
                            >
                                <i className={`fa fa-arrow-${showOrder ? 'up' : 'down'}`}></i>
                            </button>

                        </span>
                        <span className="order-date col-5 px-0 text-right">
                            <small>{insertDate.split(' ')[0]}</small>
                            <small>{insertDate.split(' ')[1]}</small>
                        </span>
                    </div>
                </header>
                <Collapse
                    id="contentcollapse"
                    in={showOrder}
                >
                    <div>
                        {
                            <section className="scrap-section p-2">
                                <div>
                                    <div className="order-facture">
                                        <h1>فاکتور</h1>
                                        <div className="d-flex flex-wrap justify-content-between mt-3">
                                            <div className="col-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 px-0 d-flex flex-column">
                                                <h6 className="font-weight-bold">اطلاعات تحویل گیرنده</h6>
                                                <span className="font-weight-bold ">
                                                    <span >نام گیرنده</span>
                                                    <span className="mx-1">:</span>
                                                    <span className="text-muted">{fullName}</span>
                                                </span>
                                                <span className="font-weight-bold ">
                                                    <span >تلفن</span>
                                                    <span className="mx-1">:</span>
                                                    <span className="text-muted">{telephone}</span>
                                                </span>
                                                <span className="font-weight-bold ">
                                                    <span >آدرس</span>
                                                    <span className="mx-1">:</span>
                                                    <p className="text-muted">{address}</p>
                                                </span>
                                                <span className="font-weight-bold ">
                                                    <span >توضیحات</span>
                                                    <span className="mx-1">:</span>
                                                    <p className="text-muted">{info}</p>
                                                </span>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 px-0 d-flex flex-column">
                                                <h6 className="font-weight-bold">محصولات خریداری شده</h6>
                                                <table className="table table-sm" style={{fontSize:'.8rem'}}>
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">#</th>
                                                            <th scope="col">نام محصول</th>
                                                            <th scope="col">تعداد</th>
                                                            <th scope="col">مبلغ</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            products.map((item, index) => 
                                                                <tr
                                                                    key={item._id}
                                                                >
                                                                    <th scope="row">{index + 1}</th>
                                                                    <td>{item.title}</td>
                                                                    <td>{item.count} {item.unit}</td>
                                                                    <td>{item.price} تومان</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 px-0 pl-xl-5">
                                                <h6 className="font-weight-bold mt-0 ">مبلغ</h6>
                                                <div className="d-flex justify-content-between ">
                                                    <span>مجموع هزینه</span>
                                                    <span>
                                                        {priceFormat(String(totalPrice))}<span className="ml-1">تومان</span>
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between mt-2">
                                                    <span>هزینه پیک</span>
                                                    <span>
                                                        {
                                                            (postPrice === 0 && status === 'unconfirmed') ?
                                                                <span className='text-muted'>هنوز مشخص نشده</span>
                                                                :
                                                                <React.Fragment>
                                                                   {priceFormat(String(postPrice))}<span className="ml-1">تومان</span>
                                                                </React.Fragment>
                                                        }
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between text-success mt-2">
                                                    <span>مبلغ پرداختی</span>
                                                    <span>
                                                        {priceFormat(String(Number(totalPrice) + Number(postPrice)))}<span className="ml-1">تومان</span>
                                                    </span>
                                                </div>
                                            </div>
                                            {
                                                status === 'unconfirmed' &&
                                                <div className="col-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 px-0 pl-xl-5">
                                                    <div className='alert alert-success small mt-3'>
                                                        برای تأیید سریع شفارش خود میتوانید با شماره های
                                                        09153218055 و یا 05130000000
                                                        تماس بگیرید. در غیر اینصورت منتظر تماس ما باشید.
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </section>
                        }
                    </div>

                </Collapse>
            </div>
        </React.Fragment>

    );
}

export default POrder;